var $384a15a899b42310$exports = {};
$384a15a899b42310$exports = {
  "collapse": "Daralt",
  "expand": "Geni\u015Flet"
};
export { $384a15a899b42310$exports as default };